import { createRole, deleteRole, getRoles, updateRole } from "../../api/role";
import * as _ from "lodash";
import moment from "moment";

const role = {
    namespaced: true,
    state: {
        roles: {
            count: 0,
            data: [],
            total: 0,
        },
    },
    mutations: {
        SET_ROLES: (state, payload) => {
            state.roles = {
                ...payload,
                data: _.sortBy(payload.data, (x) => -1 * moment(x.createdAt).valueOf()),
            };
        },
        ADD_ROLE: (state, payload) => {
            state.roles = {
                ...state.roles,
                data: _.sortBy([...state.roles.data, payload], (x) => -1 * moment(x.createdAt).valueOf()),
                total: state.roles.total + 1,
            };
        },
        UPDATE_ROLE: (state, payload) => {
            let role = state.roles.data.find((p) => p._id === payload._id);
            role = payload;
        },
        DELETE_ROLE: (state, id) => {
            state.roles.data = state.roles.data.filter((r) => r._id !== id);
            state.roles.total--;
        },
    },
    actions: {
        getRoles({ commit }, payload) {
            return getRoles(payload.perPage, payload.page).then((response) => {
                commit("SET_ROLES", response.data);
                return response.data;
            });
        },
        getRole({ state }, id) {
            return state.roles.data.find((p) => p._id === id);
        },
        createRole({ commit }, payload) {
            return createRole(payload).then((response) => {
                commit("ADD_ROLE", response.data);
            });
        },
        updateRole({ commit }, payload) {
            return updateRole(payload._id, payload).then((response) => {
                commit("UPDATE_ROLE", response.data);
            });
        },
        deleteRole({ commit }, id) {
            return deleteRole(id).then((response) => {
                commit("DELETE_ROLE", id);
            });
        },
    },
};

export default role;
